export function parseJwt<T>(token: string): T {
  const split = token.split(".");
  const second = split[1];
  if (second === undefined) throw new Error("Invalid Token");
  const json = atob(second);
  const obj = JSON.parse(json) as T;
  return obj;
}
